import { DateTime } from 'luxon';
import type { ItemState } from '@/common';

/** Today's local calendar day as YYYY-MM-DD — compute once per frame when checking many items. */
export function todayIsoDate(): string {
  return DateTime.now().toISODate() ?? '';
}

/** Not done and the deadline day (stored as UTC midnight) lies before today. */
export function isOverdue(
  deadline: string | null | undefined,
  state: ItemState | null | undefined,
  today: string = todayIsoDate(),
): boolean {
  if (!deadline || state === 'done') {
    return false;
  }

  return deadline.slice(0, 10) < today;
}
